module.exports = __webpack_public_path__ + "static/___001___Contemporary-2-5-bedroom-homes-in-Laguna-Phuket.e791efc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___001___Contemporary-2-5-bedroom-homes-in-Laguna-Phuket.jpg
// module id = 1277
// module chunks = 64098118039141